import React, { useContext, useEffect, useRef, useState } from 'react'
import './FileInput.css'
import { MdOutlineFileUpload } from 'react-icons/md';
import { ContextNotification, severitys } from '../App';
import axios from 'axios';
import { Button, Grid2, LinearProgress } from '@mui/material';
import { Height } from '@mui/icons-material';
import BeatLoading from './Loader/BeatLoader';


const FileInput = ({ formData, fileAttachmentType, refreshGrid }) => {
    const inputRef = useRef();
    const [loading, setLoading] = useState(false);
    const [refresh, setRefresh] = useState(false);
    const [msg, setMsg] = useState("")
    useEffect(()=>{
document.getElementById('fileinput').value= null;
    },[refresh])
    const handleOnChange = (event) => {
        setLoading(true);
        setMsg("");
        if (event.target.files && event.target.files.length > 0) {
            if (!excelValidation(event.target.files[0])) {
                setMsg("فرمت های مجاز xls,xlsx")
                setLoading(false);
                return;
            }
            //     if (fileAttachmentType.toString() !== enumMapper.FileAttachmentType.PassportImage.toString() && !validation.fileValidation(event.target.files[0])) {
            //         setMsg("فرمت های مجاز pdf,jpeg,jpg,png")
            //         return;
            //     }
            //     else if (fileAttachmentType.toString() === enumMapper.FileAttachmentType.PassportImage.toString()) {
            //         if (!passportValidation(event.target.files[0])) {
            //             setMsg("فرمت های مجاز jpeg,jpg")
            //             return;
            //         }
            // if (!passportSizeValidation(event.target.files[0])) {
            //     const size = event.target.files[0].size / 1024
            //     setMsg(`حجم فایل ` + formatBytes(event.target.files[0].size, 2) + ` \n حجم مجاز کمتر از 500 کیلو بایت و بیشتر از 30 کیلو بایت `)
            //     return;
            // }
        }
        formData.append("FormFile", event.target.files[0]);
        setRefresh((old)=>!(old));
        refreshGrid();
        setLoading(false);

    }

    const onChooseFile = (event) => {
        event.preventDefault();
        inputRef.current.click()

    }
    const passportValidation = (element) => {
        let valid = true;
        if (element.type !== "image/jpeg" && element.type !== "image/jpg") {
            valid = false;
        }
        return valid;
    }
    const excelValidation = (element) => {
        let valid = true;
        if ((element.type !== "application/vnd.ms-excel")&&(element.type !=="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet")) {
            valid = false;
        }
        return valid;
    }

    const passportSizeValidation = (element) => {
        let valid = true;

        const size = element.size / 1024

        if (size < 30 || size > 500) {
            valid = false;
        }
        return valid;
    }
    function formatBytes(bytes, decimals = 2) {
        if (!+bytes) return '0 Bytes'

        const k = 1024
        const dm = decimals < 0 ? 0 : decimals
        const sizes = ['بایت', 'کیلو بایت', 'مگابایت', 'گیگا بایت', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB']

        const i = Math.floor(Math.log(bytes) / Math.log(k))

        return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
    }
    return (
        <>
                <input id='fileinput' type='file'
                    name='file'
                    ref={inputRef}
                    accept='application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                    onChange={handleOnChange}
                    style={{ display: "none" }} />
                <Button className="file-btn" sx={{ height: 50 }} onClick={onChooseFile}><span style={{ display: 'flex', alignItems: 'center' }}><MdOutlineFileUpload size={20} /><span>انتخاب فایل</span></span>
                    <BeatLoading loading={loading} color={"#e65100"} size={8} />
                </Button>
                <p className="error display-linebreak">{msg}</p>

        </>
    )
}

export default FileInput